import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import React from "react";
import { useConverterPageContext } from "utils/converter-provider";
import {
  HowToBuyRedirectButton,
  HowToBuyRedirectCardContainer,
  HowToBuyRedirectCardContent,
  HowToBuyRedirectText
} from "./styles";

const HowToBuyRedirectCard: React.FC = () => {
  const t = useTranslations(FILES.CONVERTER);
  const { assetPrice } = useConverterPageContext();

  const slug = assetPrice?.toDisplayName?.toLowerCase();

  return (
    <HowToBuyRedirectCardContainer>
      <HowToBuyRedirectCardContent>
        <HowToBuyRedirectText as="h3" size="md" marketing>
          {t("howToBuyCardTitle")}
        </HowToBuyRedirectText>
        <HowToBuyRedirectButton
          size="md"
          href={`https://www.gemini.com/how-to-buy/${slug}`}
          target="_blank"
        >
          {t("learnMore")}
        </HowToBuyRedirectButton>
      </HowToBuyRedirectCardContent>
    </HowToBuyRedirectCardContainer>
  );
};

export default HowToBuyRedirectCard;
